const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "769px",
    height: "505px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.947
    },
    fill: "#8f8f8f",
    d: "M 43.5,-0.5 C 270.833,-0.5 498.167,-0.5 725.5,-0.5C 749.039,2.37368 763.373,15.3737 768.5,38.5C 768.5,181.167 768.5,323.833 768.5,466.5C 763.712,485.956 751.712,498.623 732.5,504.5C 500.167,504.5 267.833,504.5 35.5,504.5C 16.2923,498.626 4.29227,485.96 -0.5,466.5C -0.5,323.833 -0.5,181.167 -0.5,38.5C 5.39996,15.5996 20.0666,2.59959 43.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 40.5,7.5 C 269.5,7.33333 498.5,7.5 727.5,8C 744.346,11.1784 755.18,21.0117 760,37.5C 760.667,180.167 760.667,322.833 760,465.5C 756.202,482.631 745.702,493.131 728.5,497C 498.833,497.667 269.167,497.667 39.5,497C 22.3244,493.158 11.8244,482.658 8,465.5C 7.33333,322.833 7.33333,180.167 8,37.5C 13.0031,20.9904 23.8365,10.9904 40.5,7.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f72717",
    d: "M 595.5,188.5 C 595.5,189.833 596.167,190.5 597.5,190.5C 598.758,197.124 599.758,203.79 600.5,210.5C 600.157,212.483 600.824,213.817 602.5,214.5C 606.195,243.108 604.862,271.441 598.5,299.5C 597.481,298.313 596.314,297.313 595,296.5C 591.437,290.707 588.437,284.707 586,278.5C 583.825,264.257 582.991,249.924 583.5,235.5C 588.5,235.5 593.5,235.5 598.5,235.5C 599.167,228.833 599.833,222.167 600.5,215.5C 594.833,215.5 589.167,215.5 583.5,215.5C 583.832,204.813 583.499,194.146 582.5,183.5C 574.229,187.973 565.562,191.306 556.5,193.5C 556.333,218.169 556.5,242.836 557,267.5C 559.1,276.914 562.267,285.914 566.5,294.5C 566.5,295.833 567.167,296.5 568.5,296.5C 569.514,298.574 570.514,300.574 571.5,302.5C 580.381,302.845 589.048,303.845 597.5,305.5C 597.5,306.5 597.5,307.5 597.5,308.5C 596.167,308.5 595.5,309.167 595.5,310.5C 594.249,318.505 591.916,326.171 588.5,333.5C 582.383,346.57 575.716,359.237 568.5,371.5C 567.167,371.5 566.5,372.167 566.5,373.5C 534.016,420.615 489.683,451.448 433.5,466C 365.773,479.894 304.107,466.894 248.5,427C 240.75,421.09 233.417,414.59 226.5,407.5C 226.5,406.167 225.833,405.5 224.5,405.5C 209.481,390.469 197.148,373.469 187.5,354.5C 187.5,353.167 186.833,352.5 185.5,352.5C 177.518,335.85 171.184,318.516 166.5,300.5C 164.849,293.582 163.849,286.582 163.5,279.5C 163.923,277.219 163.256,275.552 161.5,274.5C 160.625,259.174 160.459,243.841 161,228.5C 162.49,221.211 163.656,213.877 164.5,206.5C 172.167,206.5 179.833,206.5 187.5,206.5C 187.5,238.5 187.5,270.5 187.5,302.5C 196.986,303.494 206.652,303.827 216.5,303.5C 216.5,271.5 216.5,239.5 216.5,207.5C 228.012,207.828 239.346,207.495 250.5,206.5C 251.632,198.512 252.632,190.512 253.5,182.5C 225.831,182.667 198.165,182.5 170.5,182C 174.555,169.729 179.555,157.895 185.5,146.5C 186.833,146.5 187.5,145.833 187.5,144.5C 197.128,125.594 209.461,108.594 224.5,93.5C 225.833,93.5 226.5,92.8333 226.5,91.5C 259.036,59.3907 298.036,39.3907 343.5,31.5C 345.483,31.8432 346.817,31.1765 347.5,29.5C 445.341,19.5277 520.841,54.861 574,135.5C 578.169,145.74 583.003,155.574 588.5,165C 588.888,169.304 590.388,173.137 593,176.5C 593.943,180.496 594.776,184.496 595.5,188.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fb786d",
    d: "M 347.5,29.5 C 346.817,31.1765 345.483,31.8432 343.5,31.5C 344.183,29.8235 345.517,29.1568 347.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fa938a",
    d: "M 226.5,91.5 C 226.5,92.8333 225.833,93.5 224.5,93.5C 224.5,92.1667 225.167,91.5 226.5,91.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fa938a",
    d: "M 187.5,144.5 C 187.5,145.833 186.833,146.5 185.5,146.5C 185.5,145.167 186.167,144.5 187.5,144.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 258.5,182.5 C 267.5,182.5 276.5,182.5 285.5,182.5C 285.5,189.167 285.5,195.833 285.5,202.5C 276.5,202.5 267.5,202.5 258.5,202.5C 258.5,195.833 258.5,189.167 258.5,182.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fffcfc",
    d: "M 397.5,183.5 C 397.5,205.5 397.5,227.5 397.5,249.5C 399.099,249.768 400.432,249.434 401.5,248.5C 409.273,237.218 417.273,226.052 425.5,215C 435.167,214.333 444.833,214.333 454.5,215C 453.421,215.956 452.255,216.789 451,217.5C 448.337,220.856 446.004,224.522 444,228.5C 441.56,229.274 440.227,230.94 440,233.5C 435.16,238.514 430.66,243.848 426.5,249.5C 425.596,250.209 425.263,251.209 425.5,252.5C 428.167,252.5 430.833,252.5 433.5,252.5C 435.179,252.892 436.846,253.392 438.5,254C 439.98,256.754 441.646,259.421 443.5,262C 447.113,276.307 451.78,290.14 457.5,303.5C 448.143,303.832 438.81,303.498 429.5,302.5C 424.912,292.805 421.578,282.638 419.5,272C 417.653,268.976 414.987,267.476 411.5,267.5C 409.603,266.195 407.269,265.529 404.5,265.5C 401.731,265.529 399.397,266.195 397.5,267.5C 397.5,279.167 397.5,290.833 397.5,302.5C 389.167,302.5 380.833,302.5 372.5,302.5C 372.5,262.833 372.5,223.167 372.5,183.5C 380.833,182.167 389.167,182.167 397.5,183.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f95c50",
    d: "M 397.5,183.5 C 398.497,204.994 398.831,226.66 398.5,248.5C 399.5,248.5 400.5,248.5 401.5,248.5C 400.432,249.434 399.099,249.768 397.5,249.5C 397.5,227.5 397.5,205.5 397.5,183.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fa938a",
    d: "M 595.5,188.5 C 596.833,188.5 597.5,189.167 597.5,190.5C 597.5,189.167 596.833,188.5 595.5,188.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fb928a",
    d: "M 250.5,206.5 C 239.346,207.495 228.012,207.828 216.5,207.5C 216.5,239.5 216.5,271.5 216.5,303.5C 206.652,303.827 196.986,303.494 187.5,302.5C 196.5,302.5 205.5,302.5 214.5,302.5C 214.5,270.5 214.5,238.5 214.5,206.5C 226.5,206.5 238.5,206.5 250.5,206.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fffcfb",
    d: "M 322.5,253.5 C 321.223,254.694 320.556,256.36 320.5,258.5C 320.556,260.64 321.223,262.306 322.5,263.5C 322.439,267.049 323.273,270.382 325,273.5C 327.85,276.683 331.016,279.516 334.5,282C 342.865,284.022 351.198,283.855 359.5,281.5C 360.647,281.182 361.481,280.516 362,279.5C 361.964,286.819 361.797,294.152 361.5,301.5C 358.167,302.167 354.833,302.833 351.5,303.5C 349.517,303.157 348.183,303.824 347.5,305.5C 342.5,305.5 337.5,305.5 332.5,305.5C 331.817,303.824 330.483,303.157 328.5,303.5C 307.95,299.06 296.617,286.393 294.5,265.5C 294.5,261.167 294.5,256.833 294.5,252.5C 295.456,239.755 300.789,229.255 310.5,221C 313.193,220.657 315.193,219.324 316.5,217C 333.571,211.007 350.571,211.173 367.5,217.5C 364.976,223.068 362.976,228.901 361.5,235C 360.66,236.171 359.827,237.338 359,238.5C 357.156,236.114 354.656,234.947 351.5,235C 341.223,232.563 332.556,235.063 325.5,242.5C 323.478,245.897 322.478,249.564 322.5,253.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fffcfc",
    d: "M 550.5,253.5 C 550.5,257.167 550.5,260.833 550.5,264.5C 528.167,264.5 505.833,264.5 483.5,264.5C 483.263,265.791 483.596,266.791 484.5,267.5C 488.353,277.688 495.686,283.354 506.5,284.5C 507.871,285.787 509.705,286.453 512,286.5C 514.295,286.453 516.129,285.787 517.5,284.5C 522.167,283.833 526.833,283.167 531.5,282.5C 532.461,284.265 532.795,286.265 532.5,288.5C 532.533,292.869 532.2,297.202 531.5,301.5C 511.877,307.804 492.877,306.304 474.5,297C 473.726,294.56 472.06,293.227 469.5,293C 462.226,286.076 457.893,277.576 456.5,267.5C 452.744,245.204 460.41,228.371 479.5,217C 499.029,209.849 517.696,211.516 535.5,222C 540.976,227.738 545.31,234.238 548.5,241.5C 549.632,245.426 550.299,249.426 550.5,253.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fb786d",
    d: "M 600.5,210.5 C 602.176,211.183 602.843,212.517 602.5,214.5C 600.824,213.817 600.157,212.483 600.5,210.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 258.5,214.5 C 267.5,214.5 276.5,214.5 285.5,214.5C 285.5,244.167 285.5,273.833 285.5,303.5C 276.5,303.5 267.5,303.5 258.5,303.5C 258.5,273.833 258.5,244.167 258.5,214.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f72c1b",
    d: "M 497.5,230.5 C 506.499,228.765 514.166,231.098 520.5,237.5C 521.805,240.053 522.805,242.72 523.5,245.5C 510.167,246.833 496.833,246.833 483.5,245.5C 485.126,242.374 486.959,239.374 489,236.5C 491.997,234.598 494.831,232.598 497.5,230.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffbfb8",
    d: "M 426.5,249.5 C 429.159,249.917 431.492,250.917 433.5,252.5C 430.833,252.5 428.167,252.5 425.5,252.5C 425.263,251.209 425.596,250.209 426.5,249.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fb9e96",
    d: "M 294.5,252.5 C 294.5,256.833 294.5,261.167 294.5,265.5C 293.2,263.777 292.533,261.61 292.5,259C 292.533,256.39 293.2,254.223 294.5,252.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9665a",
    d: "M 322.5,253.5 C 322.5,256.833 322.5,260.167 322.5,263.5C 321.223,262.306 320.556,260.64 320.5,258.5C 320.556,256.36 321.223,254.694 322.5,253.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fb9890",
    d: "M 550.5,253.5 C 551.483,257.298 551.817,261.298 551.5,265.5C 528.808,264.844 506.475,265.511 484.5,267.5C 483.596,266.791 483.263,265.791 483.5,264.5C 505.833,264.5 528.167,264.5 550.5,264.5C 550.5,260.833 550.5,257.167 550.5,253.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fb958d",
    d: "M 411.5,267.5 C 406.833,267.5 402.167,267.5 397.5,267.5C 399.397,266.195 401.731,265.529 404.5,265.5C 407.269,265.529 409.603,266.195 411.5,267.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fb857a",
    d: "M 161.5,274.5 C 163.256,275.552 163.923,277.219 163.5,279.5C 161.744,278.448 161.077,276.781 161.5,274.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fca29b",
    d: "M 506.5,284.5 C 510.167,284.5 513.833,284.5 517.5,284.5C 516.129,285.787 514.295,286.453 512,286.5C 509.705,286.453 507.871,285.787 506.5,284.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fb7c70",
    d: "M 531.5,282.5 C 531.56,281.957 531.893,281.624 532.5,281.5C 533.797,283.973 533.797,286.307 532.5,288.5C 532.795,286.265 532.461,284.265 531.5,282.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fa938a",
    d: "M 566.5,294.5 C 567.833,294.5 568.5,295.167 568.5,296.5C 568.5,295.167 567.833,294.5 566.5,294.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fc968d",
    d: "M 372.5,183.5 C 372.5,223.167 372.5,262.833 372.5,302.5C 380.833,302.5 389.167,302.5 397.5,302.5C 389.016,303.493 380.349,303.826 371.5,303.5C 371.168,263.33 371.501,223.33 372.5,183.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcaca6",
    d: "M 571.5,302.5 C 580.5,302.5 589.5,302.5 598.5,302.5C 598.737,303.791 598.404,304.791 597.5,305.5C 589.048,303.845 580.381,302.845 571.5,302.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fb8378",
    d: "M 328.5,303.5 C 330.483,303.157 331.817,303.824 332.5,305.5C 330.517,305.843 329.183,305.176 328.5,303.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fb9189",
    d: "M 351.5,303.5 C 350.817,305.176 349.483,305.843 347.5,305.5C 348.183,303.824 349.517,303.157 351.5,303.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fa938a",
    d: "M 597.5,308.5 C 597.5,309.833 596.833,310.5 595.5,310.5C 595.5,309.167 596.167,308.5 597.5,308.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fa938a",
    d: "M 185.5,352.5 C 186.833,352.5 187.5,353.167 187.5,354.5C 186.167,354.5 185.5,353.833 185.5,352.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fa938a",
    d: "M 568.5,371.5 C 568.5,372.833 567.833,373.5 566.5,373.5C 566.5,372.167 567.167,371.5 568.5,371.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fa938a",
    d: "M 224.5,405.5 C 225.833,405.5 226.5,406.167 226.5,407.5C 225.167,407.5 224.5,406.833 224.5,405.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.d042f9bfcec4a13ca5ee53234890cb48.svg";
export { ForwardRef as ReactComponent };